import { KeyValueObj } from "@/common/types";
import { ReactNode, useState } from "react";

interface IInventoryDetails {
  data: KeyValueObj;
}

const cartons: any = [{}];

const InfoItem = ({
  label,
  value,
}: {
  label: string;
  value: string | number | ReactNode;
}) => (
  <div className="flex w-full gap-2 my-2">
    <span className="text font-bold text-gray-600">{label}:</span>
    <span className="text-gray-800">{value}</span>
  </div>
);

const CartonItem = ({ data }: { data: any }) => {
  const [open, setOpen] = useState(false);
  const serial = data?.carton_units[0].serial_number;

  return (
    <div className="border-b h-full">
      <div
        onClick={() => setOpen(!open)}
        className="flex justify-between items-center py-3 cursor-pointer hover:bg-gray-50 px-2"
      >
        <span className="font-medium text-gray-700">{serial}</span>
        <span className="text-gray-500">{open ? "▲" : "▼"}</span>
      </div>

      {open && data?.carton_units.length > 0 && (
        <>
          <div className="flex justify-between">
            <div className=" px-4 pb-4">
              <span>Pack Serial</span>

              {data?.pack_units?.map((pack: any, index: any) => (
                <div
                  key={index}
                  className=" text-sm py-2 border-b last:border-none"
                >
                  <span>{pack.serial_number}</span>
                </div>
              ))}
            </div>

            <div className=" px-4 pb-4">
              <span className="font-semibold text-gray-600 text-sm py-2 border-b">
                Unit Serial
              </span>
              {data?.unit_items?.map((pack: any, index: any) => (
                <div
                  key={index}
                  className="text-sm py-2 border-b last:border-none"
                >
                  <span>{pack.serial_number}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

function InventoryDetails({ data }: IInventoryDetails) {
  return (
    <div className=" w-full">
      <div className=" bg-white shadow-md rounded-lg ">
        {/* Header */}
        <div className="p-5 space-y-6">
          {/* Product Info */}
          <div className="grid md:grid-cols-2 gap-4  text-sm">
            <InfoItem label="Product Name" value={data?.product?.brand_name} />
            <InfoItem label="Batch ID" value={data?.batch_number} />
            <InfoItem label="Manufacture Date" value={data?.manufacture_date} />
            <InfoItem label="Expiry Date" value={data?.expiry_date} />
            <InfoItem
              label="Selling Price (₦)"
              value={data?.selling_price_per_unit}
            />
            <InfoItem label="Stock Quantity" value={data?.quantity_in_stock} />
          </div>

          {/* Carton Section */}
          {data?.carton_units?.length > 0 && (
            <>
              <div className="">
                <h2 className="text-lg font-semibold text-gray-700 mb-3 mt-20 h-full">
                  Carton Serial
                </h2>

                <div className="border rounded-md divide-y">
                  {cartons.map((index: any) => (
                    <CartonItem key={index} data={data} />
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default InventoryDetails;
